export class EnvironmentHelper {
  static getEnviromentString() {
    switch (process.env.VUE_APP_BASE_URL_EVENT_FRONT) {
      case 'https://eventos.639app.com/':
        return 'Production'
      case 'https://eventos-preprod.639app.com/':
        return 'PreProduction'
      case 'https://eventos-rc.639app.com/':
        return 'Staging'
      default:
        return 'Development'
    }
  }

  static isProduction() {
    return process.env.NODE_ENV.includes('production')
  }
}
